import { PhoneFormatter } from 'field-kit';
import { parsePhoneNumber } from 'libphonenumber-js';

// XXXX XXXXXX
const REGULAR = {
  delimiterMap: {
    4: ' '
  },
  maximumLength: 11
};

// 0XXXX XXXXXX
const WITH_ZERO = {
  delimiterMap: {
    5: ' '
  },
  maximumLength: 12
};

// 44 XXXX XXXXXX
const WITH_COUNTRY_CODE = {
  delimiterMap: {
    2: ' ',
    7: ' '
  },
  maximumLength: 14
};

// +44 XXXX XXXXXX
const WITH_COUNTRY_CODE_PLUS = {
  delimiterMap: {
    3: ' ',
    8: ' '
  },
  maximumLength: 15
};

// +44 (0)XXXX XXXXXX
const WITH_COUNTRY_CODE_PARENTHESES = {
  delimiterMap: {
    3: ' ',
    4: '(',
    6: ')',
    11: ' '
  },
  maximumLength: 18
};
export default class BritishPhoneFormatter extends PhoneFormatter {
  // TODO: move over to @square/phone-number
  format(text) {
    if (!text || text.length === 0) {
      return super.format(text);
    }
    if (text.startsWith('44')) {
      text = `+${text}`;
    }
    try {
      const phoneNumber = parsePhoneNumber(text, 'GB');
      text = phoneNumber.formatNational();
    } catch {
      return text;
    }
    return text;
  }
  guessFormatFromText(text) {
    if (!text || typeof text === 'undefined') {
      super.guessFormatFromText(text);
      return;
    }
    if (text.startsWith('0')) {
      this.delimiterMap = WITH_ZERO.delimiterMap;
      this.maximumLength = WITH_ZERO.maximumLength;
    } else if (text.startsWith('44')) {
      this.delimiterMap = WITH_COUNTRY_CODE.delimiterMap;
      this.maximumLength = WITH_COUNTRY_CODE.maximumLength;
    } else if (text.startsWith('+44 (')) {
      this.delimiterMap = WITH_COUNTRY_CODE_PARENTHESES.delimiterMap;
      this.maximumLength = WITH_COUNTRY_CODE_PARENTHESES.maximumLength;
    } else if (text.startsWith('+')) {
      this.delimiterMap = WITH_COUNTRY_CODE_PLUS.delimiterMap;
      this.maximumLength = WITH_COUNTRY_CODE_PLUS.maximumLength;
    } else {
      this.delimiterMap = REGULAR.delimiterMap;
      this.maximumLength = REGULAR.maximumLength;
    }
  }
}